<template>
  <b-form
    @submit.prevent="$emit('submit', model)"
    @keydown.enter="$emit('submit', model)"
  >
    <b-row no-gutters>
      <b-col sm="12">
        <b-form-group label="Fecha entre">
          <b-row no-gutters>
            <b-col cols="6">
              <b-form-datepicker
                :value="model.date_min"
                class="margin-right-datepicker"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                size="sm"
                reset-button
                :hide-header="true"
                placeholder="Desde"
                :label-help="null"
                :max="model.date_max"
                @input="update('date_min', $event)"
                start-weekday="1"
              />
            </b-col>
            <b-col cols="6">
              <b-form-datepicker
                :value="model.date_max"
                class="margin-left-datepicker"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                size="sm"
                reset-button
                :hide-header="true"
                placeholder="Hasta"
                :label-help="null"
                :min="model.date_min"
                @input="update('date_max', $event)"
                start-weekday="1"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Job"
          label-for="order-job"
        >
          <BaseSelect
            id="job-job"
            :resource="$data.$constants.RESOURCES.RESOURCE_JOBS"
            :value="model.job"
            @input="update('job', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Nº Pedido"
          label-for="order-number"
        >
          <b-form-input
            id="order-number"
            :value="model.number"
            name="order-number"
            placeholder="Nº Pedido"
            @input="update('number', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Estado"
          label-for="order-status"
        >
          <StatusSelect
            id="order-status"
            :value="model.status"
            :type="statusType"
            @input="update('status', $event)"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          label="División"
          label-for="order-division"
        >
          <BaseSelect
            id="order-division"
            :value="model.division"
            :resource="$data.$constants.RESOURCES.RESOURCE_DIVISIONS"
            http-method="get"
            @input="update('division', $event)"
            :reduce="((item) => {return { id: item.id, name: item.name }})"
            :multiple="true"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Proveedor"
          label-for="order-provider"
        >
          <BaseSelect
            id="order-provider"
            :resource="$data.$constants.RESOURCES.RESOURCE_PROVIDERS"
            :value="model.provider"
            @input="update('provider', $event)"
            :reduce="((item) => {return { id: item.id, name: item.name }})"
            :multiple="true"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Categoría"
          label-for="order-category-group"
        >
          <CategoryGroupSelect
            id="order-category-group"
            :value="model.category_group"
            @input="update('category_group', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <b-form-checkbox
            id="order-incidences"
            :checked="model.order_incidences === 1"
            @change="update('order_incidences', $event ? 1 : null)"
          >
            Pedidos con incidencia
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import FormMixin from '@/mixins/formMixin'
import { ORDERS_STATUS_TYPE } from '@/api/status-api'
import StatusSelect from '@/components/status/select/StatusSelect.vue'
import CategoryGroupSelect from '@/components/category/select/CategoryGroupSelect.vue'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  name: 'OrdersListFiltersForm',
  components: {
    BaseSelect,
    CategoryGroupSelect,
    StatusSelect,
  },
  mixins: [FormMixin],
  data() {
    return {
      statusType: ORDERS_STATUS_TYPE,
    }
  },
}
</script>

<style scoped>
.margin-left-datepicker {
  margin-left: 5px;
}
.margin-right-datepicker {
  margin-right: 5px;
}
</style>
